import { useCurrentOrg } from 'new/hooks/adapters/useCurrentOrg';
import { ORGANIZATION_STATUS, TrialPlanMessageMap } from '@nexla/@types';

/**
 * @NOTES
 * unlimited is true if trial_period_days is -1
 * expired is true if the org status is TRIAL_EXPIRED
 * quotaLimitExceeded is true if org status is SOURCE_COUNT_CAPPED or SOURCE_DATA_CAPPED
 */
export default function useOrganizationTrialStatus() {
  const organization = useCurrentOrg();

  const tier = organization?.org_tier;
  const periodDays = Number(tier?.trial_period_days);
  const isUnlimited = periodDays === -1;

  if (!tier || isUnlimited) {
    return {
      tier: null,
      isUnlimited: true,
    };
  }

  const isExpired = organization.status === ORGANIZATION_STATUS.TRIAL_EXPIRED;
  const { status } = organization;
  const quotaLimitExceeded =
    ORGANIZATION_STATUS.SOURCE_COUNT_CAPPED === status ||
    ORGANIZATION_STATUS.SOURCE_DATA_CAPPED === status;

  const keyMessage =
    organization.status !== ORGANIZATION_STATUS.ACTIVE ? organization?.status : tier.name;

  const label = TrialPlanMessageMap[keyMessage];

  return {
    tier,
    label,
    isExpired,
    quotaLimitExceeded,
  };
}
